<template>
    <div>
        <div class="sticky z-0 text-gray-900 my-rounded top-10">
            <div class="pt-4">
                <template v-if="user">
                    <div class="flex items-center mb-5">
                        <div
                        class="rounded-full"
                        style="
                        background-image: url('https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRFsAoaCvF_W3KpyowaGT2TmB4SlF_mjbHDvU2WK42W2Q44K0MbSSRAhRWDzf8Q1AYHEms&usqp=CAU');
                        background-size: cover;
                        background-position: center center;
                        width: 35px;
                        height: 35px;
                        "></div>
                        <h6 class="mb-0 ml-2" style="text-transform: capitalize">{{ user.prenom + ' ' + user.nom }}</h6>
                    </div>
                    <hr>
                </template>
                <template v-if="!user">
                    <router-link :to="{ name: 'user.login'}" style="text-decoration: none">
                        <div :class="isSelect('user.login') ? 'text-gray-900 bg-gray-100' : 'text-gray-600'" class="flex items-center mb-0 h6 navigation font-weight-light" style="border-top-right-radius: 15px; border-bottom-right-radius: 15px;">
                            <div style="width: 2px; height: 45px;" class="mr-3 bg-gray-600 separator my-rounded"></div>
                            <i class="mr-3 fas fa-user"></i>{{$t('template.menu.casino.se_connecter')}}
                        </div>
                    </router-link>
                    <router-link :to="{ name: 'user.login.actors'}" style="text-decoration: none">
                        <div :class="isSelect('user.login.actors') ? 'text-gray-900 bg-gray-100' : 'text-gray-600'" class="flex items-center mb-0 h6 navigation font-weight-light" style="border-top-right-radius: 15px; border-bottom-right-radius: 15px;">
                            <div style="width: 2px; height: 45px;" class="mr-3 bg-gray-600 separator my-rounded"></div>
                            <i class="mr-3 fas fa-plus"></i>{{$t('template.menu.casino.s_inscrire')}}
                        </div>
                    </router-link>
                </template>
                <template v-if="user">
                    <router-link :to="{ name: 'form.home'}" style="text-decoration: none">
                        <div class="py-3 my-5 text-center text-white my-rounded h6" style="background: #006e31">
                            <i class="mr-3 fas fa-plus"></i>{{formAlreadyExists ? $t('template.menu.casino.continuer_la_demande') : $t('template.menu.casino.nouvelle_demande')}}
                        </div>
                    </router-link>
                    <router-link :to="{ name: 'home'}" style="text-decoration: none">
                        <div :class="isSelect('home') ? 'text-gray-900 bg-gray-100' : 'text-gray-600'" class="flex items-center mb-0 h6 navigation font-weight-light" style="border-top-right-radius: 15px; border-bottom-right-radius: 15px;">
                            <div style="width: 2px; height: 45px;" class="mr-3 bg-gray-900 separator my-rounded"></div>
                            <i class="mr-3 fas fa-home"></i>{{$t('template.menu.casino.accueil')}}
                        </div>
                    </router-link>
                    <router-link :to="{ name: 'user.notifications'}" style="text-decoration: none">
                        <div :class="isSelect('user.notifications') ? 'text-gray-900 bg-gray-100' : 'text-gray-600'" class="flex items-center mb-0 h6 navigation font-weight-light" style="border-top-right-radius: 15px; border-bottom-right-radius: 15px;">
                            <div style="width: 2px; height: 45px;" class="mr-3 bg-gray-900 separator my-rounded"></div>
                            <i class="fas fa-bell"></i>
                            <div v-if="newNotifs" class="-mt-2 -ml-1.5 mr-2 w-3 mb-2 font-medium leading-tight text-2xl bg-red-400 border-2 border-white rounded-full"></div>
                            <span :class="!newNotifs ? 'ml-3' : ''">{{$t('template.menu.casino.notifications')}}</span>
                        </div>
                    </router-link>
                    <h6 class="my-3 text-gray-600">
                        <small class="font-weight-light">{{$t('template.menu.casino.mes_dossiers')}}</small>
                    </h6>
                    <router-link :to="{ name: 'user.folder.requests'}" style="text-decoration: none">
                        <div :class="isSelect('user.folder.requests') ? 'text-gray-900 bg-gray-100' : 'text-gray-600'" class="flex items-center mb-0 h6 navigation font-weight-light" style="border-top-right-radius: 15px; border-bottom-right-radius: 15px;">
                            <div style="width: 2px; height: 45px;" class="mr-3 bg-gray-600 separator my-rounded"></div>
                            <i class="mr-3 fas fa-folder-plus"></i>{{$t('template.menu.casino.mes_demandes')}}
                        </div>
                    </router-link>
                    <router-link :to="{ name: 'user.product.list'}" style="text-decoration: none">
                        <div :class="isSelect('user.product.list') ? 'text-gray-900 bg-gray-100' : 'text-gray-600'" class="flex items-center mb-0 h6 navigation font-weight-light" style="border-top-right-radius: 15px; border-bottom-right-radius: 15px;">
                            <div style="width: 2px; height: 45px;" class="mr-3 bg-gray-600 separator my-rounded"></div>
                            <i class="mr-3 fas fa-tag"></i>{{$t('template.menu.casino.mes_produits')}}
                        </div>
                    </router-link>
                    <!-- <router-link :to="{ name: 'user.folder.list'}" style="text-decoration: none">
                        <div :class="isSelect('user.folder.list') ? 'text-gray-900 bg-gray-100' : 'text-gray-600'" class="flex items-center mb-0 h6 navigation font-weight-light" style="border-top-right-radius: 15px; border-bottom-right-radius: 15px;">
                            <div style="width: 2px; height: 45px;" class="mr-3 bg-gray-600 separator my-rounded"></div>
                            <i class="mr-3 fas fa-folder"></i>{{$t('menu.8')}}
                        </div>
                    </router-link> -->
                    <h6 class="my-3">
                        <small class="font-weight-light">{{$t('template.menu.casino.mon_compte')}}</small>
                    </h6>
                    <router-link :to="{ name: 'user.update'}" style="text-decoration: none">
                        <div :class="isSelect('user.update') ? 'text-gray-900 bg-gray-100' : 'text-gray-600'" class="flex items-center mb-0 h6 navigation font-weight-light" style="border-top-right-radius: 15px; border-bottom-right-radius: 15px;">
                            <div style="width: 2px; height: 45px;" class="mr-3 bg-gray-600 separator my-rounded"></div>
                            <i class="mr-3 fas fa-cog"></i>{{$t('template.menu.casino.parametres')}}
                        </div>
                    </router-link>
                    <router-link :to="{ name: 'user.logout'}" style="text-decoration: none">
                        <div :class="isSelect('user.logout') ? 'text-gray-900 bg-gray-100' : 'text-gray-600'" class="flex items-center mb-0 h6 navigation font-weight-light" style="border-top-right-radius: 15px; border-bottom-right-radius: 15px;">
                            <div style="width: 2px; height: 45px;" class="mr-3 bg-gray-600 separator my-rounded"></div>
                            <i class="mr-3 fas fa-sign-out-alt"></i>{{$t('template.menu.casino.deconnexion')}}
                        </div>
                    </router-link>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import apiService from '@/services/api.service'

export default {
    data() {
        return {
            user: null,
            notifs: [],
            langage: 'fr'
        }
    },
    watch: {
        langage: function(value) {
            this.$i18n.locale = value
            localStorage.setItem('langage', value)
        }
    },
    computed: {
        newNotifs() {
            if (this.notifs) {
                return this.notifs.find(notif => notif.lu == "0")
            }
        },

        formAlreadyExists() {
            return localStorage['form-data'] && JSON.parse(localStorage['form-data']).sign ? true : false
        }
    },
    methods: {
        isSelect(routeName) {
            return (
                this.$route.name.split('.')[0] == routeName
                || this.$route.name == routeName
            ) ? true : false
        },
        async getNotifs() {
            if (this.user) {
                await apiService.post('getnotif', {
                    id_conso: this.user.id
                }).then((response) => {
                    this.notifs = response.data.posts.post
                })
            }
        }
    },
    async mounted() {
        let userStorage = localStorage.getItem('user-session')
        userStorage = userStorage ? JSON.parse(userStorage) : null

        const d = new Date();
        let currentTime = d.getTime();

        if (userStorage && userStorage.user && (currentTime - userStorage.time) < 600000) {
            this.user = userStorage.user
        } else {
            this.user = await apiService.getUser()
            localStorage.setItem('user-session', JSON.stringify({
                user: await apiService.getUser(),
                time: currentTime
            }))
        }

        // Change langage
        let defaultLang = navigator.language || navigator.userLanguage
        if (localStorage.getItem('langage')) {
            defaultLang = localStorage.getItem('langage')
        }
        this.langage = defaultLang
        this.$i18n.locale = defaultLang

        this.getNotifs()
    },
}
</script>



// WEBPACK FOOTER //
// src/companies/casino/views/template/CasinoSideMenuLargeScreen.vue